import React from 'react';
import styled from 'styled-components';

import RnRHeader from '../RnRHeader/RnRHeader';
import RnRReview from '../RnRReview/RnRReview';
import UserReview from '../UserReview/UserReview';

const RnRAllcomponent = () => (
  <RnRAllComponentWrapDiv>
    <RnRHeader></RnRHeader>
    <RnRReview></RnRReview>
    <UserReview></UserReview>
  </RnRAllComponentWrapDiv>
);

export default RnRAllcomponent;

const RnRAllComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  margin-top:${props.theme.spacing.xlarge};

`,
);
